var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayWall && !_vm.isZazosUser)?_c('ThePaywallWall',{on:{"ctaClick":_vm.notifyContact}}):(_vm.isAdmin && _vm.isTrial)?_c('ThePaywallBar',{on:{"ctaClick":_vm.notifyContact}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }